import { useContext, useEffect } from "react";
import { UserStore } from "../..";

/**
 * While `count` is above zero: ask the browser to confirm before unload, and
 * tell the app shell so a venue switch confirms before remounting the page.
 */
export const useUnsavedChangesWarning = (count: number, noun: string) => {
  const userStore = useContext(UserStore);

  useEffect(() => {
    if (count === 0) {
      userStore.setUnsavedWork(null);
      return;
    }

    userStore.setUnsavedWork(
      `${count} unsaved ${noun}${count === 1 ? "" : "s"}`
    );

    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = ""; // required by Chrome to show the prompt
    };
    window.addEventListener("beforeunload", warn);

    return () => {
      window.removeEventListener("beforeunload", warn);
      userStore.setUnsavedWork(null);
    };
  }, [count, noun, userStore]);
};
